import { render, staticRenderFns } from "./CollateralBankList.vue?vue&type=template&id=2e512891&"
import script from "./CollateralBankList.vue?vue&type=script&lang=js&"
export * from "./CollateralBankList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports